export default "__VITE_ASSET__bJohW8cZ__"